import React from 'react';
interface CardProps {
  className?: string;
  children: React.ReactNode;
}
export const Card: React.FC<CardProps> = ({
  className = '',
  children
}) => {
  return <div className={`bg-white border border-gray-6 rounded-lg p-6 ${className}`} data-id="element-550">
      {children}
    </div>;
};
interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
}
export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  icon
}) => {
  return <Card className="flex flex-col" data-id="element-551">
      <div className="flex items-center justify-between mb-4" data-id="element-552">
        <h3 className="text-sm font-medium text-gray-11" data-id="element-553">{title}</h3>
        {icon && <div className="text-gray-10" data-id="element-554">{icon}</div>}
      </div>
      <div className="text-3xl font-bold text-gray-12" data-id="element-555">{value}</div>
      {subtitle && <div className="mt-2 text-sm text-gray-10" data-id="element-556">{subtitle}</div>}
    </Card>;
};